import './main.css';
import { Elm } from './Main.elm';

async function startElm() {

    customElements.define('embed-matter', class extends HTMLElement {
        set content(html) {
            this.insertAdjacentHTML('beforeend', html);
        }
    });

    const flags = await fetch("/data.json")
        .then(res => res.json())
        .catch(e => {
            console.error(e);
            return null;
        });

    var app = Elm.Main.init({
        node: document.getElementById('root'),
        flags: flags
    });
}
startElm();
